import { useQuery } from "@apollo/client";
import { MarketingLimitsQuery } from "../graphql/queries";
import type {
  MarketingLimitsQueryType,
  MarketingLimitsQueryVariablesType,
} from "@/types/graphql/partner.generated";
import type { MarketingLimits } from "../model/types";

/**
 * Пределы рассылок и аудитории. Запрос один на сессию (cache-first), все
 * редакторы читают его из кеша. null, пока ответа нет или запрос упал
 * (например, старый бэкенд без marketingLimits): ограничения ввода в
 * кабинете тогда не действуют, сохранение проверяет бэкенд.
 */
export function useMarketingLimits(): MarketingLimits | null {
  const { data } = useQuery<
    MarketingLimitsQueryType,
    MarketingLimitsQueryVariablesType
  >(MarketingLimitsQuery, { fetchPolicy: "cache-first" });
  return data?.marketingLimits ?? null;
}
